import { find } from 'lodash'
import React from 'react'
import { addValidator } from 'redux-form-validators'
import { conformToMask, phoneNumberMask } from '../../utils/inputMasks'

export { phoneNumberMask }
export const CUSTOMER_SUPPORT_PHONE_NUMBER = '8007936107'
export const PHONE_ERROR = 'Enter a valid phone number.'
export const CODE_PLACEHOLDER = 'Enter verification code'
export const CODE_ERROR = 'Enter the 6-digit verification code.'

export const verificationCodeMask = Array(6).fill(/\d/)

export const numbersOnly = val => {
  return typeof val === 'string' ? val && val.replace(/[^0-9]/g, '') : ''
}

export const isValidPhone = value => numbersOnly(value).length === 10

export const formatPhoneNumber = phoneNumber =>
  conformToMask(phoneNumber, phoneNumberMask).conformedValue

const GENERATE_PHONE_OTP_ERROR_MAP = {
  TOO_MANY_REQUESTS: "We can't send you any more codes. Try back in an hour.",
  INVALID_PHONE_NUMBER: 'We only allow US phone numbers.',
  VOIP_PHONE_NUMBER_NOT_ALLOWED:
    "Enter a different phone number. We don't support VOIPs.",
  NOT_A_MOBILE_PHONE:
    'Enter a mobile phone number to receive verification code via SMS.',
  PHONE_ALREADY_VERIFIED_BY_ANOTHER_USER:
    'This phone number is already in use.',
  PHONE_SUSPENDED: (
    <>
      Please call{' '}
      <a href={`tel:${CUSTOMER_SUPPORT_PHONE_NUMBER}`}>
        {formatPhoneNumber(CUSTOMER_SUPPORT_PHONE_NUMBER)}
      </a>{' '}
      and our Customer Care Team will assist you.
    </>
  ),
  DEFAULT: 'Failed to send the verification code.',
}

const VERIFY_PHONE_OTP_ERROR_MAP = {
  TOO_MANY_REQUESTS: "You've tried too many times. Try again tomorrow.",
  INCORRECT_VERIFICATION_CODE:
    "The code you entered can't be confirmed. Check the code and try again.",
  EXPIRED_OR_NON_EXISTENT_VERIFICATION: 'The verification code has expired.',
  DEFAULT: 'Failed to verify the code.',
}

export const getSendCodeErrorMessage = errorCode =>
  GENERATE_PHONE_OTP_ERROR_MAP[errorCode] ||
  GENERATE_PHONE_OTP_ERROR_MAP.DEFAULT
export const getVerifyCodeErrorMessage = errorCode =>
  VERIFY_PHONE_OTP_ERROR_MAP[errorCode] || VERIFY_PHONE_OTP_ERROR_MAP.DEFAULT

export const getLatestPhone = phoneList =>
  find(phoneList, 'verified') || phoneList[0] || null

export const validatePhoneNumber = addValidator({
  defaultMessage: PHONE_ERROR,
  validator: (options, value) => isValidPhone(value),
})
